import {
  makeCreateWidgetAction,
  type MakeCreateWidgetActionDeps,
  type WidgetActionProcessor,
  type WidgetActionSchema,
} from '@/entities/widget';
import { SocialOpportunitiesWidgetKey } from '@inference.engine/widgets/web';
import { SocialOpportunitiesWidget } from '@inference.engine/widgets';

/**
 * Factory that binds the SocialMediaOpportunities widget processor to the
 * supplied dep surface. Returns the processor list consumed by the central
 * widget dispatcher in `features/widgets/processors/`.
 *
 * The widget slice MUST NOT value-import `widgetProcessorDeps` from
 * `@/features/widgets/processors/...`. The dispatcher binds with deps once.
 */
export const makeProcessors = (deps: MakeCreateWidgetActionDeps): WidgetActionProcessor[] => {
  const create: WidgetActionProcessor<WidgetActionSchema<SocialOpportunitiesWidget>> = {
    key: SocialOpportunitiesWidgetKey,
    processor: makeCreateWidgetAction(deps) as WidgetActionProcessor<
      WidgetActionSchema<SocialOpportunitiesWidget>
    >['processor'],
  };
  return [create];
};
